import { render } from "./quizThumbsUpDown.vue?vue&type=template&id=701c9440"
import script from "./quizThumbsUpDown.vue?vue&type=script&lang=js"
export * from "./quizThumbsUpDown.vue?vue&type=script&lang=js"

import "./quizThumbsUpDown.vue?vue&type=style&index=0&id=701c9440&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__